import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Slide from "@mui/material/Slide";
import { setClearSnackBar } from "../../../redux/slices/snackbar";

function TransitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

const Alert = React.forwardRef((props, ref) => {
  const { snackBar } = useSelector((state) => state.snackBar);
  return (
    <MuiAlert
      elevation={6}
      ref={ref}
      variant="filled"
      {...props}
      sx={{
        color: snackBar.color,
        fontSize: "15px",
        fontWeight: 400,
        backgroundColor: "white",
        borderLeft: `8px solid ${snackBar.borderColor}`,
        fontFamily: "Inter !important",
        boxShadow: "5px 10px 20px 0px rgba(0, 0, 0, 0.10) !important",
      }}
    />
  );
});

const AppSnackBar = () => {
  const dispatch = useDispatch();
  const { snackBar } = useSelector((state) => state.snackBar);
  function handleClose() {
    dispatch(setClearSnackBar(undefined));
  }

  return (
    <Snackbar
      open={snackBar?.snackBarOpen}
      autoHideDuration={4000}
      onClose={handleClose}
      TransitionComponent={TransitionLeft}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert onClose={handleClose} sx={{ width: "100%" }} icon={snackBar.Icon}>
        {snackBar?.snackBarMessage}
      </Alert>
    </Snackbar>
  );
};

export default AppSnackBar;
